<script setup lang="ts">
/* The title block every page inside the shell starts with.
   Primary/secondary buttons go in the `actions` slot. */
defineProps<{ title: string; description?: string }>()
</script>

<template>
  <header class="header">
    <div class="text">
      <h1 class="title">{{ title }}</h1>
      <p v-if="description" class="description">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="actions"><slot name="actions" /></div>
  </header>
</template>

<style scoped>
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-sm);
  margin-bottom: var(--space-md);
}

.text {
  min-width: 0;
}

.title {
  font-size: var(--text-lg);
  letter-spacing: var(--tracking-tight);
}

.description {
  margin-top: var(--space-3xs);
  max-width: 60ch;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2xs);
}

/* Wrap to a new line rather than squeeze a label to an ellipsis. */
.actions > * {
  flex-shrink: 0;
}

/* On a phone the actions get a row of their own and share it, so Edit and
   Delete sit side by side instead of stair-stepping down the page. */
@media (max-width: 40rem) {
  .actions {
    width: 100%;
  }

  .actions > * {
    flex: 1 1 auto;
  }
}
</style>
